export const GEN2 = 'gen2'
export const GEN3 = 'gen3'
